export const buildSelectOptions = <T>(
    data: T[],
    labelKey: keyof T,
    valueKey: keyof T
  ) => {
    return data.map(item => ({
      label: String(item[labelKey]),
      value: item[valueKey],
    }));
};

export const isAbortedError = (err: unknown): boolean => {
    if (!err || typeof err !== 'object') {
        return false;
    }

    const error = err as { name?: string; code?: string };
    return (
        error.name === 'CanceledError' ||
        error.name === 'AbortError' ||
        error.code === 'ERR_CANCELED'
    );
};


export const PROJECT_OWNER_ROLE = 'project_team_roles_3';
export const PROJECT_MANAGER_ROLE = 'project_team_roles_4';
export const PROJECT_LEAD_ROLE = 'project_team_roles_1';